import React, { useEffect } from 'react';
import ModalContentBase from '../redux/components/modal/modal_content_base';

const SectionIsMultiplePurchase = ({ circle, event, setEvent, isNew, multiplePurchaseError }) => {
  // ユーザーが自分でトグルを触ったかどうか（自動補正の再適用を防ぐため）
  const hasUserToggled = React.useRef(false);

  // 新規作成時はデフォルトでオン（年齢制限・男女比調整がない場合のみ）
  useEffect(() => {
    if (!isNew || hasUserToggled.current) return;
    if (event.is_gender_managed || event.is_age_limited) return;
    if (event.is_multiple_purchase_allowed === true) return;

    setEvent(prev => ({
      ...prev,
      is_multiple_purchase_allowed: true
    }));
  }, [event.is_multiple_purchase_allowed, event.is_gender_managed, event.is_age_limited, isNew, setEvent]);

  // 年齢制限または男女比調整がオンになったら自動的にオフにする
  useEffect(() => {
    if (!isNew) return;
    if ((event.is_gender_managed || event.is_age_limited) && event.is_multiple_purchase_allowed) {
      setEvent(prev => ({
        ...prev,
        is_multiple_purchase_allowed: false
      }));
    }
  }, [isNew, event.is_gender_managed, event.is_age_limited, event.is_multiple_purchase_allowed, setEvent]);

  const isRestricted = event.is_gender_managed || event.is_age_limited;
  const isMultiplePurchaseAllowed = (!isNew && isRestricted)
    ? event.is_multiple_purchase_allowed  // 既存イベントはDBの値をそのまま表示
    : isRestricted
      ? false
      : (hasUserToggled.current
        ? event.is_multiple_purchase_allowed
        : event.is_multiple_purchase_allowed ?? (isNew ? true : false));

  const previewContent = (
    <span>
      <img src="/img/question.png" className="" height="auto" style={{ width: "15px" }} />
    </span>
  );

  const modalContent = (
    <div>
      <div className="modal-view-header">
        <p style={{ margin: "0 0 6px", padding: "1.5em", textAlign: "left" }}>
          <strong>
            <p>
              友達分チケット購入設定とは
            </p>
          </strong>
        </p>
      </div>
      <div
        className="modal-view-body"
        style={{ padding: "0px 25px 50px", textAlign: "left" }}
      >
        <p className="pb-3">一人のユーザが参加チケットを友達分も購入できるようにする設定です。</p>
        <p className="pb-3">参加者が同行者の分もまとめて購入できるようになります。</p>
        <p className="pb-3">参加者側の安心感を高め、当日キャンセルの減少や満足度の向上が期待できます。</p>
        <p className="pb-3">同行者は、参加者の欄には（購入者の名前）の友達と表示されます。</p>
      </div>
      <div className="modal-view-footer" />
    </div>
  );

  return (
    <section id="multiple_purchase">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            友達分チケット購入設定
          </p>
          <div className="ml-1 mt-3-5">
            <ModalContentBase
              previewContent={previewContent}
              modalContent={modalContent}
            />
          </div>
        </div>
        <p className="text-gray text-fz-small mt-0 mb-1">
          {isRestricted && !(!isNew && isMultiplePurchaseAllowed)
            ? '※男女比調整または募集年齢制限が設定されているため、友達分のチケット購入は利用できません。イベント初回作成時のみ設定できます。あとから変更できません。'
            : '※イベント初回作成時のみ設定できます。あとから変更できません。'}
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="is_multiple_purchase"
              checked={!!isMultiplePurchaseAllowed}
              onChange={(e) => {
                hasUserToggled.current = true;
                const checked = e.target.checked;
                setEvent((prev) => ({
                  ...prev,
                  is_multiple_purchase_allowed: checked,
                }));
              }}
              disabled={!isNew || isRestricted}
            />
            <label
              className="custom-control-label"
              htmlFor="is_multiple_purchase"
            >
              友達分のチケット購入を許可する
            </label>
          </div>
          {multiplePurchaseError && (
            <p className="text-danger text-fz-small mt-2 mb-0">{multiplePurchaseError}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default SectionIsMultiplePurchase;
